import React from "react";

// Define props interface
interface DroneSpecsProps {
  specs: { [key: string]: string };
  extraGears: string[]; // Add extraGears prop
}

// Accept props and use them
const DroneSpecs: React.FC<DroneSpecsProps> = ({ specs, extraGears }) => {
  // Remove static specs array
  /*
  const specs = [
    { label: "Camera", value: "20 megapixel 1-inch CMOS" },
    { label: "Sensor with 4K/60fps video", value: "" },
    { label: "Max Flight Time", value: "28 minutes" },
    { label: "Max Speed", value: "45 mph (72 km/h)" },
    { label: "Transmission Range", value: "4.3 miles (7 km)" },
    { label: "Obstacle Sensing System", value: "5 directions" },
    { label: "Remote Controller Frequency", value: "2.4 GHz/5.8 GHz" },
  ];
  */

  // Handle case where specs might be empty or null
  const hasSpecs = specs && Object.keys(specs).length > 0;
  const hasExtraGears = extraGears && extraGears.length > 0;

  return (
    <div className="mb-6">
      {/* Specs Section */}
      {hasSpecs && (
        <>
          <h2 className="text-2xl font-bold mb-4">Drone Specs</h2>
          <div className="space-y-2">
            {Object.entries(specs).map(([label, value], index) => (
              <div
                key={label}
                className={`flex ${index % 2 === 0 ? "bg-gray-100" : ""} p-2 rounded`}
              >
                <span className="font-semibold w-1/2">{label}</span>
                <span className="w-1/2">{value}</span>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Extra Gear Section */}
      {hasExtraGears && (
        <>
          <h2 className={`text-2xl font-bold mt-6 mb-4 ${hasSpecs ? 'mt-6' : ''}`}>Extra Gear Included</h2>
          <ul className="list-disc list-inside space-y-1">
            {extraGears.map((gear, index) => (
              <li key={index}>{gear}</li>
            ))}
          </ul>
        </>
      )}

      {/* Message if no specs and no extra gear */}
      {!hasSpecs && !hasExtraGears && (
        <>
          <h2 className="text-2xl font-bold mb-4">Drone Specs & Gear</h2>
          <p>No specifications or extra gear details available.</p>
        </>
      )}
    </div>
  );
};

export default DroneSpecs;
